/** @jsxImportSource @emotion/react */

import { Fragment, ReactElement } from 'react';
import { HtmlComponentProp } from '../../types'

type Props = {
  component: HtmlComponentProp
  key: number
}

function HtmlComponent({ component }: Props): ReactElement {
  return (
    <Fragment>
      <div dangerouslySetInnerHTML={{ __html: component.html }} />
    </Fragment>
  )
}

export default HtmlComponent
